var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"message loading"},[_c('div',{staticClass:"bubble"},[_c('avatar-robot')],1),_c('img',{attrs:{"src":_vm.baseUrl + 'ellipsis.gif',"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }